export const STATE_NAME = 'loginSystem';
export const AUTHENTICATE = 'AUTHENTICATE';
export const AUTHENTICATE_DONE = 'AUTHENTICATE_DONE';
export const AUTHENTICATE_FAIL = 'AUTHENTICATE_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const LOAD_CACHED_USER_ATTEMPTED = 'LOAD_CACHED_USER_ATTEMPTED';
export const LOGOUT = 'LOGOUT';
